module.exports = __webpack_public_path__ + "4a4f38c154079628593dffb406e0c520.png";